



















import { Component, Vue, Model, Emit, Prop } from 'vue-property-decorator';
import { post, get } from '@/unite/api';
import moment from 'moment';
@Component({
  components: {}
})
export default class EditAllowed extends Vue {
  @Prop() data: any;
  mounted() {
    this.getSub();
    if (this.data.subs) {
      this.dynamicTags = this.data.subs;
    }
  }
  dialogVisible: boolean = true;
  dynamicTags: any = [];
  options: object[] = [];
  inputVisible: boolean = false;
  inputValue: string = '';
  handleDelete(tag: any) {
    this.inputVisible = false;
    get(`/back/v1/cg/refuse?id=${this.data.id}&sub_id=${tag.id}`, {})
      .then(d => {
        this.$message.success('操作成功！');
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      })
      .catch();
  }

  private showInput() {
    this.inputVisible = true;
  }
  private closeInput(value: boolean) {
    if (!value) {
      this.inputVisible = false;
    }
  }
  private handleInputConfirm() {
    if (!this.inputValue) {
      return;
    }
    let inputValue = this.inputValue;
    get(`/back/v1/cg/allowed?id=${this.data.id}&sub_id=${this.inputValue}`, {})
      .then(d => {
        this.$message.success('操作成功！');
        // @ts-ignore
        let arr = this.options.filter(item => item.id === inputValue);
        console.log(arr);
        if (inputValue) {
          this.dynamicTags.push(arr[0]);
        }
        this.inputVisible = false;
        this.inputValue = '';
      })
      .catch();
  }
  private handleClose(value: boolean) {
    this.$emit('refesh', true);
  }
  private getSub() {
    get('/back/v1/sub/list?page_num=10000&page_index=1', {}).then(d => {
      // @ts-ignore
      this.options = d.Content.list;
    });
  }
}
